export const removeTimezoneFromDateString = (date: string): string =>
  date.substring(0, 23)
